import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallerDateEvent } from '@/models/caller';
import type { CallerDateEventsQueryVariables } from '@/gql/graphql';

export const fetchCallerDateEvents = async ({
  callerId,
  date,
  endDate,
  includeRides,
  includeRideActivities,
  includeServiceChecks,
  includeScheduledRides,
  includeScheduledRideHistories,
  includeCallLogs,
  includeTextMessages,
}: CallerDateEventsQueryVariables): Promise<CallerDateEvent> => {
  const response = await queryExecute({
    query: graphql(`
      query CallerDateEvents(
        $callerId: String!
        $date: String!
        $endDate: String!
        $includeRides: Boolean
        $includeRideActivities: Boolean
        $includeServiceChecks: Boolean
        $includeScheduledRides: Boolean
        $includeScheduledRideHistories: Boolean
        $includeCallLogs: Boolean
        $includeTextMessages: Boolean
      ) {
        callerDateEvents(
          callerId: $callerId
          date: $date
          endDate: $endDate
          includeRides: $includeRides
          includeRideActivities: $includeRideActivities
          includeServiceChecks: $includeServiceChecks
          includeScheduledRides: $includeScheduledRides
          includeScheduledRideHistories: $includeScheduledRideHistories
          includeCallLogs: $includeCallLogs
          includeTextMessages: $includeTextMessages
        ) {
          customerName
          phoneNumber
          timeZone
          rides {
            id
            orderedBy
            status
            startLocation
            destination
            noteToDriver
            createdAt
          }
          rideActivities {
            id
            rideId
            userId
            action
            description
            createdAt
          }
          serviceChecks {
            id
            streetAddress
            streetAddress2
            city
            state
            zip
            country
            eta
            createdAt
          }
          scheduledRides {
            id
            pickupDate
            pickupTime
            streetAddress1
            city1
            state1
            zip1
            streetAddress2
            city2
            state2
            zip2
          }
          scheduledRideHistories {
            id
            scheduledRideId
            action
            reason
            createdAt
          }
          callLogs {
            id
            fromPhoneNumber
            toPhoneNumber
            purpose
            notes
            callFlow
            createdAt
          }
          textMessages {
            id
            fromPhoneNumber
            toPhoneNumber
            purpose
            message
            createdAt
          }
        }
      }
    `),
    variables: {
      callerId,
      date,
      endDate,
      includeRides,
      includeRideActivities,
      includeServiceChecks,
      includeScheduledRides,
      includeScheduledRideHistories,
      includeCallLogs,
      includeTextMessages,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.callerDateEvents!;
};
